(() => {
  const engravingCta = document.getElementById('engraving-cta');
  const giftPersonal = document.getElementById('gift-personal');
  const closeButton = document.getElementById('close-x-button');

  if (!engravingCta || !giftPersonal || !closeButton) return;

  const setState = (active) => {
    giftPersonal.hidden = !active;
    giftPersonal.setAttribute('aria-hidden', String(!active));

    closeButton.hidden = !active;

    engravingCta.classList.toggle('is-active', active);
  };

  engravingCta.addEventListener('click', () => {
    setState(giftPersonal.hidden);
  });

  closeButton.addEventListener('click', (e) => {
    e.stopPropagation();
    setState(false);
  });
})();